export * from './home.component';
export * from './patient-add/patient-add.component';
